import jwt from "jsonwebtoken";
import { useHistory } from 'react-router-dom';
import ConnUrls from "./MyConns/Connections/ConnectURL";
import utilsBuisUser from "./MyConns/_Utils/utilsBuisUser";




const sortAsc = (arr, field) => {
    return arr.sort((a, b) => {
        if (a[field] > b[field]) { return 1; }
        if (b[field] > a[field]) { return -1; }
        return 0;
    })
}




const sortDsc = (arr, field) => {
    return arr.sort((a, b) => {
        if (a[field] < b[field]) { return 1; }
        if (b[field] < a[field]) { return -1; }
        return 0;
    })
}


const sortByItemAsc = (arr, field, ordUserOrBuiss) => {

    if (ordUserOrBuiss == "ord") {
        return arr.sort((a, b) => {
            if (a[field] > b[field]) { return 1; }
            if (b[field] > a[field]) { return -1; }
            return 0;
        })
    }
    else if (ordUserOrBuiss == "buiss") {
        return arr.sort((a, b) => {
            if (a.buiss[field] > b.buiss[field]) { return 1; }
            if (b.buiss[field] > a.buiss[field]) { return -1; }
            return 0;
        })
    }

    else if (ordUserOrBuiss == "theUser") {
        return arr.sort((a, b) => {
            if (a.theUser[field] > b.theUser[field]) { return 1; }
            if (b.theUser[field] > a.theUser[field]) { return -1; }
            return 0;
        })
    }
}


const sortByItemDsc = (arr, field, ordUserOrBuiss) => {

    if (ordUserOrBuiss == "ord") {
        return arr.sort((a, b) => {
            if (a[field] < b[field]) { return 1; }
            if (b[field] < a[field]) { return -1; }
            return 0;
        })
    }
    else if (ordUserOrBuiss == "buiss") {
        return arr.sort((a, b) => {
            if (a.buiss[field] < b.buiss[field]) { return 1; }
            if (b.buiss[field] < a.buiss[field]) { return -1; }
            return 0;
        })
    }
    else if (ordUserOrBuiss == "theUser") {
        return arr.sort((a, b) => {
            if (a.theUser[field] < b.theUser[field]) { return 1; }
            if (b.theUser[field] < a.theUser[field]) { return -1; }
            return 0;
        })
    }
}






const checkToken = async (toeknToCheck) => {

    let theUsr = await utilsBuisUser.checkToken(toeknToCheck);
    return theUsr;

}

const connCheck = async () => {

    const token = localStorage.getItem('token');
    if (token) {
        const user = jwt.decode(token);
        if (!user) {
            localStorage.removeItem('token');
            goLogin();
        }
        else {
            let usr = await checkToken(token);

            if (usr.user != null) {
                return usr;
            }
            else {
                localStorage.removeItem('token');
                goLogin();
            }
        }
    }
    else {
        goLogin();
    }
}

const goLogin = () => {
    if (!window.location.href.includes('/Login') && !window.location.href.includes('/resPass')) {
        return window.location.href = '/Login'
    }

}





const getOrderTotalPrice = (theOrder) => {
    let tot = 0;
    if (theOrder.OrderType == "Deliver") {
        tot = parseInt(theOrder.OrderDelPrice);
    }
    theOrder.Orders.map((item, index) => {

        if (item.specials.length > 0) {
            item.specials.map((special, specialIndex) => {
                special.spec.map((spec, specIndex) => {
                    if (parseFloat(spec.addToPrice) > -1) {
                        tot += parseFloat(spec.addToPrice) * parseInt(item.mount);
                    }
                })
            })
        }
        tot += parseFloat(item.prodPrice) * parseInt(item.mount);

    })

    return tot;
}

const getOrderPrice = (theOrder) => {
    let tot = 0;

    theOrder.Orders.map((item, index) => {

        if (item.specials.length > 0) {
            item.specials.map((special, specialIndex) => {
                special.spec.map((spec, specIndex) => {
                    if (parseFloat(spec.addToPrice) > -1) {
                        tot += parseFloat(spec.addToPrice) * parseInt(item.mount);
                    }
                })
            })
        }
        tot += parseFloat(item.prodPrice) * parseInt(item.mount);

    })

    return tot;
}

const hearBling = () => {

    let ad = new Audio(ConnUrls.servMediasUrl + "Sounds/bell1.wav");
    ad.play();
}

const getListByBuisId = (OrdrsList, userBuis) => {
    if (userBuis != null) {
        let ordsNew = OrdrsList.find(itm => itm.buisId == userBuis)
        OrdrsList = ordsNew;
    }
    return (OrdrsList || [])
}




const animateList = () => {
    return (
        [
            "בחר",
            "bounce",
            "flash",
            "pulse",
            "rubberBand",
            "shakeX",
            "shakeY",
            "headShake",
            "swing",
            "tada",
            "wobble",
            "jello",
            "heartBeat",
            "backInDown",
            "backInLeft",
            "backInRight",
            "backInUp",
            "backOutDown",
            "backOutLeft",
            "backOutRight",
            "backOutUp",
            "bounceIn",
            "bounceInDown",
            "bounceInLeft",
            "bounceInRight",
            "bounceInUp",
            "bounceOut",
            "bounceOutDown",
            "bounceOutLeft",
            "bounceOutRight",
            "bounceOutUp",
            "fadeIn",
            "fadeInDown",
            "fadeInDownBig",
            "fadeInLeft",
            "fadeInLeftBig",
            "fadeInRight",
            "fadeInRightBig",
            "fadeInUp",
            "fadeInUpBig",
            "fadeInTopLeft",
            "fadeInTopRight",
            "fadeInBottomLeft",
            "fadeInBottomRight",
            "fadeOut",
            "fadeOutDown",
            "fadeOutDownBig",
            "fadeOutLeft",
            "fadeOutLeftBig",
            "fadeOutRight",
            "fadeOutRightBig",
            "fadeOutUp",
            "fadeOutUpBig",
            "fadeOutTopLeft",
            "fadeOutTopRight",
            "fadeOutBottomRight",
            "fadeOutBottomLeft",
            "flip",
            "flipInX",
            "flipInY",
            "flipOutX",
            "flipOutY",
            "lightSpeedInRight",
            "lightSpeedInLeft",
            "lightSpeedOutRight",
            "lightSpeedOutLeft",
            "rotateIn",
            "rotateInDownLeft",
            "rotateInDownRight",
            "rotateInUpLeft",
            "rotateInUpRight",
            "rotateOut",
            "rotateOutDownLeft",
            "rotateOutDownRight",
            "rotateOutUpLeft",
            "rotateOutUpRight",
            "hinge",
            "jackInTheBox",
            "rollIn",
            "rollOut",
            "zoomIn",
            "zoomInDown",
            "zoomInLeft",
            "zoomInRight",
            "zoomInUp",
            "zoomOut",
            "zoomOutDown",
            "zoomOutLeft",
            "zoomOutRight",
            "zoomOutUp",

            "slideInDown",
            "slideInLeft",
            "slideInRight",
            "slideInUp",

            "slideOutDown",
            "slideOutLeft",
            "slideOutRight",
            "slideOutUp"
        ]
    )
}

const validPhone = (phone) => {

    if (phone !== "") {
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (!pattern.test(phone)) {
            return false
        } else if (phone.length != 10 && phone.length != 9) {
            return false
        }
        else {
            return true;
        }
    }
}
const validEmail = (email) => {
    if (email !== "") {
        var pattern = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        if (!pattern.test(email)) {
            return false
        }
        else {
            return true;
        }
    }
}

const valid6DigsPassword = (password) => {
    if (password !== "") {
        //לפחות ספרה 1 ואות אחת, מינימום 6 תווים
        let pattern = new RegExp('(?=.*[a-zA-Z])(?=.*\\d).{6,}');
        if (!pattern.test(password)) {
            return false
        }
        else {
            return true;
        }
    }
}
const validPassword = (password) => {
    if (password !== "") {
        let pattern = new RegExp('^(?=.*[a-zA-Z])(?=.*\\d).{6,}$');
        if (!pattern.test(password)) {
            return false;
        } else {
            return true;
        }
    }
}


//המחיר הכולל של המוצר כולל תוספות מחיר של נלווים
const getItemTotalPrice = (item) => {

    let totItms = 0;

    // Map through prodOptions and calculate total price for selected options
    item.prodOptions?.forEach((optionGroup) => {
        const selectedOptions = optionGroup.options.filter((opt) => opt.selected);
        totItms += getSelectedOptionsPrice(selectedOptions); // שימוש בפונקציה getSelectedOptionsPrice
    });

    // Calculate and return the total price
    return (parseInt(item.basePrice) + parseFloat(totItms)) * parseInt(item.mount);

}


const getSelectedOptionsPrice = (selectedOptions) => {
    // Initialize total items to 0
    let totItms = 0;

    // Check if selectedOptions array is not empty
    if (selectedOptions.length > 0) {
        totItms = selectedOptions.reduce((total, item) => {
            // Parse addToPrice to ensure it's a number or default to 0
            const addToPrice = parseFloat(item.addToPrice || 0);

            // Check if addToPrice is valid and greater than 0
            if (!isNaN(addToPrice) && addToPrice > 0) {
                // Ensure mount is at least 1
                const mount = item.mount > 0 ? item.mount : 1;

                // Add to the total
                return total + addToPrice * mount;
            }

            // Skip invalid items
            return total;
        }, 0);
    }
    // Return the final total, parsed as a float for safety
    return parseFloat(totItms);
};




export default {
    validPhone,
    validEmail,
    valid6DigsPassword,
    validPassword,
    animateList,
    sortAsc,
    sortDsc,
    sortByItemAsc,
    sortByItemDsc,
    connCheck,
    checkToken,
    getOrderTotalPrice,
    getOrderPrice,
    goLogin,
    hearBling,
    getListByBuisId,
    getItemTotalPrice,
    getSelectedOptionsPrice


};